export default __webpack_public_path__ + "static/media/u21.dff53f09.png";